<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                memberForm: () => import('../forms/MemberForm'),
                fields: [
                    { type: 'autocomplete', text: 'Member', value: 'memberId', rules: [v => !!v || 'Member is required'], isRequired: true, form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'textarea', text: 'Message', value: 'message', rules: [v => !!v || 'Message is required'], isRequired: true, maxLength: false }
                ],
                apiMethod: 'Requests',
                formTitle: 'Request',
            }
        },
    };
</script>
